// extracted by mini-css-extract-plugin
module.exports = {"read-more-link":"read-more-link___3sWvO","readMoreLink":"read-more-link___3sWvO"};